module.exports = __webpack_public_path__ + "static/media/ecoV.ebcabda6.svg";